import http from 'hub-http/clients/apiClient';
import { makeSimpleQuickFetchWrapper } from '../../utils/ajaxUtils';
import { getKnowledgeBaseEmptyState } from '../data/KnowledgeBase';
const API_BASE = '/knowledge-content/v1/knowledge-base';

// to include only needed properties for KnowledgeBaseRecord
const ALLOWED_KNOWLEDGE_BASE_RECORD_PROPERTIES = Object.keys(getKnowledgeBaseEmptyState());
export let ProgressStatus;
(function (ProgressStatus) {
  ProgressStatus["PENDING"] = "PENDING";
  ProgressStatus["PROCESSING"] = "PROCESSING";
  ProgressStatus["COMPLETE"] = "COMPLETE";
  ProgressStatus["CANCELED"] = "CANCELED";
})(ProgressStatus || (ProgressStatus = {}));
export default class KnowledgeBaseApi {
  static update(id, data) {
    return http.put(`${API_BASE}/${id}`, {
      data
    });
  }
  static asyncCreate(data) {
    return http.post('knowledge-content/v1/knowledge-base/setup/async', {
      data
    });
  }
  static getAsyncCreateProgress(taskId) {
    return http.get(`knowledge-content/v1/knowledge-base/setup/async/tasks/${taskId}/status`);
  }
  static onboardingCreate(data) {
    return http.post(`knowledge-content/v2/setup`, {
      data
    });
  }
  static getOnboardingCreateStatus(taskId) {
    return http.get(`knowledge-content/v2/setup/${taskId}`);
  }
  static getKnowledgeBaseTheme(themeSettingId) {
    return http.get(`designmanager/v1/themes/settings/${themeSettingId}`);
  }
}
KnowledgeBaseApi.get = makeSimpleQuickFetchWrapper('get-kb', () => http.get(`${API_BASE}/`, {
  query: {
    property: ALLOWED_KNOWLEDGE_BASE_RECORD_PROPERTIES
  }
}));